/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ExperienceRequest } from './';
import {
    ExperienceRequestFromJSON,
    ExperienceRequestFromJSONTyped,
    ExperienceRequestToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdateExperiencesRequest
 */
export interface UpdateExperiencesRequest {
    /**
     * 
     * @type {Array<ExperienceRequest>}
     * @memberof UpdateExperiencesRequest
     */
    experiences: Array<ExperienceRequest>;
}

/**
 * Check if a given object implements the UpdateExperiencesRequest interface.
 */
export function instanceOfUpdateExperiencesRequest(value: object): value is UpdateExperiencesRequest {
    if (!('experiences' in value) || value['experiences'] === undefined) return false;
    return true;
}

export function UpdateExperiencesRequestFromJSON(json: any): UpdateExperiencesRequest {
    return UpdateExperiencesRequestFromJSONTyped(json, false);
}

export function UpdateExperiencesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateExperiencesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'experiences': ((json['experiences'] as Array<any>).map(ExperienceRequestFromJSON)),
    };
}

export function UpdateExperiencesRequestToJSON(value?: UpdateExperiencesRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'experiences': ((value['experiences'] as Array<any>).map((v) => ExperienceRequestToJSON(v))),
    };
}

